import { createContext } from 'react';

export const SettingsHeaderActionsPortalContext = createContext<HTMLElement | null>(null);
